import { render, staticRenderFns } from "./smileys.vue?vue&type=template&id=37cbd22c&scoped=true&"
import script from "./smileys.vue?vue&type=script&lang=js&"
export * from "./smileys.vue?vue&type=script&lang=js&"
import style0 from "./smileys.vue?vue&type=style&index=0&id=37cbd22c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cbd22c",
  null
  
)

export default component.exports